import UserService from "../../../services/UserService";
import { required, email, minLength, sameAs, maxLength } from "vuelidate/lib/validators";
import { alertResponseError, alertResponseSuccess } from "../../../helpers/general";
import { ERRORS_CODE } from "../../../const/error_code";
import { checkRoleAdmin } from "../Mixin/checkRoleAdmin";
import { ROLE } from "../../../const/role";
import AuthService from "../../../services/AuthService";

export default {
    mixins: [checkRoleAdmin],
    data() {
        return {
            isAllowEdit: false,
            isAdmin: false,
            formAction: '',
            formSubmitted: false,
            errors: {},
            roles: ROLE,
            user: {
                id: '',
                email: '',
                first_name: '',
                last_name: '',
                password: '',
                password_confirm: '',
                admin: 0,
            }
        }
    },
    validations() {
        if (this.formAction === 'create') {
            return {
                user: {
                    first_name: { required, maxLength: maxLength(30) },
                    last_name: { required, maxLength: maxLength(150) },
                    email: { required, email, maxLength: maxLength(254) },
                    password: {
                        required,
                        minLength: minLength(6),
                        isInvalid(value) {
                            return /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/.test(value);
                        }
                    },
                    password_confirm: { required, sameAsPassword: sameAs('password') },
                }
            }
        } else {
            return {
                user: {
                    first_name: { required, maxLength: maxLength(30) },
                    last_name: { required, maxLength: maxLength(150) },
                    email: { required, email, maxLength: maxLength(254) },
                }
            }
        }
    },
    created() {
        document.title = this.$t(`${this.$route.meta.title}.title_page`);
        if (this.$route.name !== 'UserCreate') {
            const userId = this.$route.params.id;
            this.formAction = 'edit';
            this.getUserWithId(userId);
        } else {
            this.formAction = 'create';
            const loginUser = JSON.parse(localStorage.getItem('user'));
            this.checkRoleAdmin(loginUser);
        }
    },
    computed: {
        errorsCode() {
            return ERRORS_CODE;
        },
        emailErrorMsg() {
            if (!this.$v.user.email.required) {
                return this.$t('common_errors.required', { field: this.$t('common.mail_address') });
            }
            if (!this.$v.user.email.email) {
                return this.$t('message_error.EMAIL_INVALID');
            }
            if (!this.$v.user.email.maxLength) {
                return this.$t('common_errors.max_lenght', { max: this.$v.user.email.$params.maxLength.max });
            }
            if (this.errors && this.errors.email) {
                if (this.errors.email[0] === ERRORS_CODE.INVALID) {
                    return this.$t('message_error.EMAIL_INVALID');
                } else if (this.errors.email[0] === ERRORS_CODE.UNIQUE) {
                    return this.$t('common_errors.unique', { field: this.$t('common.mail_address') });
                } else {
                    return this.errors.email[0];
                }
            }
            return null;
        },
        firstnameErrorMsg() {
            if (!this.$v.user.first_name.required) {
                return this.$t('common_errors.required', { field: this.$t('common.first_name') });
            }
            if (!this.$v.user.first_name.maxLength) {
                return this.$t('common_errors.max_lenght', { max: this.$v.user.first_name.$params.maxLength.max });
            }
            if (this.errors && this.errors.first_name) {
                return this.errors.first_name[0];
            }
            return null;
        },
        lastnameErrorMsg() {
            if (!this.$v.user.last_name.required) {
                return this.$t('common_errors.required', { field: this.$t('common.last_name') });
            }
            if (!this.$v.user.last_name.maxLength) {
                return this.$t('common_errors.max_lenght', { max: this.$v.user.last_name.$params.maxLength.max });
            }
            if (this.errors && this.errors.last_name) {
                return this.errors.last_name[0];
            }
            return null;
        },
        passwordErrorMsg() {
            if (!this.$v.user.password.required) {
                return this.$t('common_errors.required', { field: this.$t('common.password') });
            }
            if (!this.$v.user.password.isInvalid) {
                return this.$t('common_errors.password_invalid', { field: this.$t('common.password'), min: this.$v.user.password.$params.minLength.min });
            }
            if (this.errors && this.errors.password) {
                if (this.errors.password[0] === ERRORS_CODE.INVALID) {
                    return this.$t('common_errors.password_invalid', { field: this.$t('common.password') });
                } else {
                    return this.errors.password[0];
                }
            }
            return null;
        },
    },
    methods: {
        getUserWithId(userId) {
            UserService.getUserWithId(userId).then((response) => {
                this.user = response.data.data;
                const loginUser = JSON.parse(localStorage.getItem('user'));
                this.checkRoleAdmin(loginUser);
            }).catch((error) => {
                if (error.response.data.errorCode === ERRORS_CODE.USER_NOT_FOUND) {
                    alertResponseError(this.$t('user_detail.user_not_found')).then((value) => {
                        if (value) {
                            this.$router.push({ name: 'User' });
                        }
                    });
                } else {
                    alertResponseError(error);
                }
            })
        },
        handleForm() {
            this.errors = {};
            this.formSubmitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                if (this.formAction === 'create') {
                    UserService.createUser(this.user).then((response) => {
                        this.formSubmitted = false;
                        if (response.data.success) {
                            alertResponseSuccess(this.$t('common_message.create_success'));
                            this.$router.push({ name: 'UserManagement' });
                        }
                    }).catch((error) => {
                        // case don't have response from server
                        this.handleError(error);
                    });
                } else {
                    UserService.updateUser(this.user).then((response) => {
                        this.formSubmitted = false;
                        if (response.data.success) {
                            const userId = AuthService.getUserCurrentLogin().id;
                            AuthService.getUserAfterUpdate(userId);
                            alertResponseSuccess(this.$t('common_message.update_success'));
                            this.$router.push({ name: 'UserManagement' });
                        }
                    }).catch((error) => {
                        // case don't have response from server
                        this.handleError(error);
                    })
                }
            }
        },
        handleError(error) {
            if (!error.response || !error.response.data) {
                alertResponseError(error);
                return;
            }
            if (error.response.data.errorCode === ERRORS_CODE.VALIDATION_ERROR) {
                const rawErrors = error.response.data.msg;
                this.errors = rawErrors ? rawErrors : {};
                return;
            }
            if (error.response.data.errorCode === ERRORS_CODE.CANNOT_REGISTER_USER_WITHOUT_ORGANIZATION) {
                alertResponseError(this.$t('message_error.CANNOT_REGISTER_USER_WITHOUT_ORGANIZATION'))
                    .then((value) => {
                        if (value) {
                            this.$router.push({ name: 'Organization' });
                        }
                    });
                return;
            }
            this.errors = error.response.data.msg;
            alertResponseError(error.response.data.errorCode);
        },
    }
}
